<template>
  <v-app class="custom_bg ma-0 pa-0">
    <v-container>
      <v-row id="printMe">
        <v-col cols="12" md="12">
          <div>
            <v-btn
              color="primary"
              @click="back()"
              depressed
              class="d-print-none"
              >Back</v-btn
            >
          </div>
          <div class="d-flex align-center justify-center">
            <v-card id="print" class="black--text" outlined light>
              <v-col cols="12" md="12">
                <v-card-text class="black--text">
                  <div class="d-flex align-center justify-center mb-3">
                    <p class="custom_text">
                      {{ new Date(compt.created_at).toLocaleDateString() }}
                    </p>

                    <div class="mx-12">
                      <v-img
                        :src="compt.business_logo"
                        width="70"
                        alt="Business logo"
                        style="-webkit-print-color-adjust: exact !important"
                      ></v-img>
                    </div>

                    <p class="custom_text">
                      sales reciept <br />
                      {{ compt.order_id }}
                    </p>
                  </div>
                  <v-simple-table class="d-print-table black--text" dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="custom_text text-left">Name</th>
                          <th class="custom_text text-left">Qty</th>
                          <th class="custom_text text-left">Unit Price</th>
                          <th class="custom_text text-left">Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in it" :key="item.pid">
                          <td>
                            <span class="custom_text"> {{ item.product }} </span>
                          </td>
                          <td>
                            <span class="custom_text">{{ item.qty }} </span>
                          </td>
                          <td>
                            <span class="custom_text"> N{{ item.amount }} </span>
                          </td>
                          <td>
                            <span class="custom_text">
                            N{{
                              JSON.parse(item.amount) * JSON.parse(item.qty)
                            }}.00
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-list-item>
                    <v-list-item-title> <span class="custom_text"> Total Item </span> </v-list-item-title>
                    <v-list-item-title>
                     <span class="custom_text"> {{ it.length }} </span>
                    </v-list-item-title>
                    <v-list-item-title> <span class="custom_text"> Sub Amount </span> </v-list-item-title>
                    <v-list-item-title class="custom_text">
                    <span class="custom_text">  N{{
                        JSON.parse(compt.total_amount) +
                          JSON.parse(compt.discount)
                      }}
                      </span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title class="custom_text text-wrap">
                      Total Quantity
                    </v-list-item-title>
                    <v-list-item-title class="custom_text text-wrap">
                      {{ lg }}
                    </v-list-item-title>
                    <v-list-item-title class=" custom_text text-wrap">
                      Discount Account
                    </v-list-item-title>
                    <v-list-item-title class="custom_text text-wrap">
                      {{ compt.discount }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <div>
                      <p class="primary--text py-0 mb-0 text-body-1 custom_text text-wrap">
                        <v-divider></v-divider>
                        Total Amount N{{ compt.total_amount }}
                      </p>
                      <v-divider></v-divider>
                    </div>
                  </v-card-actions>
                  <div class="text-center">
                    <v-list-item dense>
                      <v-list-item-title>
                        <span class="custom_text">Cash Tendered</span>
                      </v-list-item-title>
                      <v-list-item-title>
                        <span class="custom_text">N{{ compt.amount_paid }}</span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item dense>
                      <v-list-item-title>
                        <span class="custom_text">Balance Amount</span>
                      </v-list-item-title>
                      <v-list-item-title>
                        <span class="custom_text"
                          >N{{ compt.total_amount - compt.amount_paid }}</span
                        >
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item dense>
                      <v-list-item-title>
                        <span class="custom_text">Customer Name</span>
                      </v-list-item-title>
                      <v-list-item-title>
                        <span class="custom_text">{{ compt.customer_name }}</span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item dense>
                      <v-list-item-title>
                        <span class="custom_text">Payment Method</span>
                      </v-list-item-title>
                      <v-list-item-title>
                        <span class="custom_text">{{ compt.payment_method }}</span>
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item dense>
                      <v-list-item-title>
                        <span class="custom_text">Sale Made By</span>
                      </v-list-item-title>
                      <v-list-item-title>
                        <span class="custom_text">{{ compt.staff_name }}</span>
                      </v-list-item-title>
                    </v-list-item>
                    <p class="custom_text">{{ compt.business_name }}</p>
                    <p class="text-body-2 mt-0 custom_text">Thanks for your patronage</p>
                  </div>
                  <div class="ml-3 d-print-none hidden-md-and-up text-center">
                    <v-btn icon class="d-print-none" @click="print()"
                      ><v-icon>mdi-download</v-icon></v-btn
                    >
                    <v-btn icon @click="print()" class="d-print-none"
                      ><v-icon>mdi-printer</v-icon></v-btn
                    >
                  </div>
                </v-card-text>
              </v-col>
            </v-card>
            <div class="ml-3 d-print-none hidden-sm-and-down">
              <div class="my-2">
                <v-btn
                  icon
                  class=".d-print-none"
                  @click="print('printable')"
                  outlined
                  ><v-icon>mdi-download</v-icon></v-btn
                >
              </div>
              <div>
                <v-btn icon @click="print()" class="d-print-none" outlined
                  ><v-icon>mdi-printer</v-icon></v-btn
                >
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    isLoading: false,
    items: [],
    model: null,
    step: 1,
    search: null,
    added: [],
    exDate: "",
    discount: 0,
    method: ["Bank transfer/ Mobile Mobile Money", "POS", "Cash"],
    totalSum: 0,
    count: 1,
    newC: false,
    existC: false,
    form: {
      name: "",
      paid: "",
      payable: "",
    },
    names: [],
    compt: [],
    it: [],
    tr: "",
    loaderC: false,
    output: "receipt.pdf",
    myArr: [],
  }),

  methods: {
    back() {
      this.$router.back();
    },
    print() {
      window.setTimeout(() => {
        window.focus();
        window.print();
      }, 100);
    },

    comp() {
      this.loaderC = true;
      const data = {
        id: this.$route.params.id,
      };
      fetch(
        "https://receipt.drecsoft.com/api/v1/sales/sale-details",

        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
          body: JSON.stringify(data),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          let docs = response.data;
          this.compt = docs.sales;
          docs.sales_products.forEach((element) => {
            let data = {
              amount: element.amount,
              qty: element.qty,
              product: element.product?.name,
            };
            this.it.push(data);
          });
        })
        .catch((err) => {
          console.log(err);
          this.loaderC = false;
        });

      console.log(">>>>>>>>");
    },
  },

  created() {
    this.comp();
  },

  computed: {
    ...mapGetters(["getUser", "currentUser", "getCustomers"]),

    sum() {
      return this.total - this.discount;
    },
    bal() {
      return this.sum - this.form.paid;
    },
    lg() {
      return this.it.reduce(
        (acc, item) => JSON.parse(acc) + JSON.parse(item.qty),
        0
      );
    },
  },
};
</script>

<style type="text/css" media="print" scoped>
body {
  visibility: hidden;
}
.noprintarea {
  visibility: hidden;
  display: none;
}
.noprintcontent {
  visibility: hidden;
}
.print {
  visibility: visible;
  display: block;
}
.custom_bg {
  background: #f6f7ff;
  height: 100%;
}

.scroll {
  overflow-y: scroll;
}

td,
th,
tr,
table {
  border-top: 1px solid black;
  border-collapse: collapse;
}

.centered {
  text-align: center;
  align-content: center;
}

.ticket {
  width: 155px;
  max-width: 155px;
}

.custom_text {
  color: #000 !important;
  font-weight: bold !important;
  font-family: sans-serif;
}

img {
  max-width: inherit;
  width: inherit;
}

@media print {
  .hidden-print,
  .hidden-print * {
    display: none !important;
  }
}
</style>
